<style scoped>
.float-bottom {
  position: fixed;
  bottom:20px;
  z-index: 2;
}

</style>

<template>
  <v-row align="end" justify="center">
    <v-col
      class="float-bottom"
      cols=auto
      lg=6
      md=8
      sm=8
      xs=12
    >
      <v-alert
        dismissible
        icon=info
        border="bottom"
        elevation=8
        class="grey--text"
        transition="scale-transition"
        v-on:input="dismiss"
      >
        Reddit Watch uses cookies to ensure you get the best experience on our website. 
        <router-link
          to="/privacy"
        >
          <span class="grey--text">Learn More</span>
        </router-link>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
export default {
  methods: {
    dismiss: function(state) {
      // Save the dismissed state to localStorage
      localStorage.showCookiePrompt = state;
    }
  },
  data: () => ({
  }),
};
</script>
